import Settings from 'configs/Settings';

import Request from '@hotmart/request';

Request.register(`${Settings.api.community}/v4/`, {
  get: {
    'notification.count': 'comment/pending/count',
    'get.support-list': 'support/list',
    'get.support-export': 'support/export',
    'get.context-comment-by-id': 'comment/:commentId',
    'get.config-notifications': 'config',
    'get.history-comments': 'history/:commentUserId',
    'get.support-imported-last': 'support/imported/last'
  },
  post: {
    'post.comments-filter': 'comment/filter?size=:size&page=:page&sort=:sort',
    'post.comment-answer-macro': 'commentAnswer/macro',
    'post.support-import': {
      path: 'support/import',
      options: {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    },
    'post.config-notifications': 'config',
    'post.comment-status-mass-update': 'commentStatus/massUpdate',
    'post.comment-status-update': 'commentStatus/update',
    'post.comment-answer-reply': 'commentAnswer/reply',
    'post.comments-history-reply':
      'history/reply?size=:size&page=:page&sort=:sort'
  }
});
